import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { constants } from '../../../config';
import { ScreenStore } from '../../../stores/ScreenStore';
import { CartStore } from '../../../stores/CartStore';
import { DeletedProductCard } from '../deleted-product-card';
import { TableCard } from '../table-card';
import styles from './ProductTable.css';

const IPropTypes = {
  className: PropTypes.string,
  isCart: PropTypes.bool.isRequired,
};

const defaultProps = {
  className: '',
};

const ProductTable = (props) => {
  const list = props.isCart ? CartStore.cart : CartStore.favorites;
  const itemCount = props.isCart ?
    CartStore.cartTotalItems :
    (CartStore.favorites || []).length;
  const mobileVersion = ScreenStore.screenWidth <= constants.breakpoints.extraSmallMaxWidth;
  return (
    <div className={props.className}>
      {
        !mobileVersion &&
        <div className={styles.header}>
          <p className={styles.articleHeader}>
            Artículos ({itemCount})
          </p>
          <p className={styles.headerItem}>
            Precio
          </p>
          <p className={styles.headerItem}>
            {
              props.isCart
                ? 'Cantidad'
                : 'Acciones'
            }
          </p>
        </div>
      }
      <div className={styles.tableContent}>
        {
          props.isCart &&
          !!CartStore.lastDeletions &&
          !!CartStore.lastDeletions.length &&
          CartStore.lastDeletions.map(element => (
            <DeletedProductCard
              className={styles.deletedCard}
              product={element.item.product}
              key={`${props.isCart ? element.item.product.id : element.item.id}-${element.serviceVersion}`}
              hasService={element.serviceVersion}
            />
          ))
        }
        {
          itemCount > 0 &&
          list.map((item) => {
            if (!props.isCart) {
              return (
                <TableCard
                  className={styles.tableCard}
                  key={item.id}
                  item={item}
                  isCartItem={false}
                />
              );
            }
            if (item.product.id === constants.productIdCreditCardTax) {
              return null;
            }
            // If the product has service booked, then we need to show
            // it as two different cards. One with service and another without.
            return (
              <React.Fragment key={item.product.id}>
                {
                  (item.serviceAmount > 0) &&
                  <TableCard
                    className={styles.tableCard}
                    item={item}
                    isCartItem
                    hasService
                    maxAmount={item.product.maxAmountToSell - (item.amount - item.serviceAmount)}
                  />
                }
                {
                  (item.serviceAmount < item.amount) &&
                  <TableCard
                    className={styles.tableCard}
                    item={item}
                    isCartItem
                    maxAmount={item.product.maxAmountToSell - item.serviceAmount}
                  />
                }
              </React.Fragment>
            );
          })
        }
        {
          itemCount === 0 &&
          props.isCart &&
          <p className={styles.noContentMessage}>
            No tenés artículos guardados en tu carrito, agregalos seleccionando
            &nbsp;&quot;Agregar al carrito&quot;
          </p>
        }
        {
          itemCount === 0 &&
          !props.isCart &&
          <p className={styles.noContentMessage}>
            No tenés artículos guardados en favoritos, agregalos seleccionando
            &nbsp;&quot;Agregar a favoritos&quot;
          </p>
        }
      </div>
    </div>
  );
};

ProductTable.propTypes = IPropTypes;
ProductTable.defaultProps = defaultProps;

const ObservedProductTable = observer(ProductTable);

export { ObservedProductTable as ProductTable };



// WEBPACK FOOTER //
// ./src/pages/cart/product-table/ProductTable.jsx